import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import NoEntriesMessage from "../../../../components/common/NoEntriesMessage/NoEntriesMessage";
import SearchWatchListEntriesForm from "../../components/search-watch-list-entries-form";
import {
  watchListEntriesSelector,
  nationalitiesOptionsSelector,
  watchListEntriesPageInfoSelector,
  watchListEntriesLoadingSelector,
  noEntriesMessageWatchListSelector,
} from "../../selectors";
import WatchListEntriesTable from "../../components/watch-list-entries-table";
import { getNationalities } from "../../../../actions";
import {
  changeCurrentPageWatchListEntries,
  changeItemsPerPageWatchListEntries,
  clearWatchListEntries,
  deleteWatchListEntry,
} from "../../actions";

import "./watchListEntriesPage.css";
import Pagination from "../../../../components/Pagination/Pagination";
import { PageTitle } from "../../../../components/common";
import FullscreenLoader from "../../../../layouts/FullScreenLoader";

const WatchListEntriesPage = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(watchListEntriesLoadingSelector);
  const watchListEntries = useSelector(watchListEntriesSelector);
  const { itemsPerPage, currentPage } = useSelector(
    watchListEntriesPageInfoSelector
  );
  const nationalities = useSelector(nationalitiesOptionsSelector);
  const [isOpenCollapse, setIsOpenCollapse] = useState(true);
  const toggleCollapse = () => setIsOpenCollapse(!isOpenCollapse);

  const [currentItems, setCurrentItems] = useState([]);
  const noEntriesMessage = useSelector(noEntriesMessageWatchListSelector);

  useEffect(() => {
    if (watchListEntries.length > 0) {
      setCurrentItems(watchListEntries.slice(0, itemsPerPage));
    }
  }, [watchListEntries]);

  useEffect(() => {
    dispatch(getNationalities());
    return () => {
      dispatch(clearWatchListEntries());
    };
  }, []);

  const onPageChange = (_, page) => {
    const startFrom = page * itemsPerPage;
    const slicedItems = watchListEntries.slice(
      startFrom,
      (page + 1) * itemsPerPage
    );

    dispatch(changeCurrentPageWatchListEntries(page + 1));
    setCurrentItems(slicedItems);
  };

  const onRowsPerPageChange = ({ target }) => {
    dispatch(changeCurrentPageWatchListEntries(1));
    const slicedItems = watchListEntries.slice(0, target.value);
    dispatch(changeItemsPerPageWatchListEntries(target.value));
    setCurrentItems(slicedItems);
  };

  const handleDelete = (id) => {
    dispatch(deleteWatchListEntry(id));
  };

  return (
    <Container className="watch-list-entries-main col-12">
      <PageTitle title="single manual search" />
      <FullscreenLoader loading={isLoading} />

      <SearchWatchListEntriesForm
        isOpenCollapse={isOpenCollapse}
        toggleCollapse={toggleCollapse}
        nationalities={nationalities}
        watchListEntries={watchListEntries}
      />
      {watchListEntries.length ? null : (
        <div className="monitoring-queue-entries-page-background-logo" />
      )}
      {watchListEntries.length > 0 ? (
        <React.Fragment>
          <WatchListEntriesTable
            canEdit={false}
            watchListEntries={currentItems}
            handleDelete={handleDelete}
          />
          {watchListEntries.length && (
            <Row className="pagination-row mt-5 mb-5">
              <Pagination
                count={watchListEntries.length}
                onPageChange={onPageChange}
                onRowsPerPageChange={onRowsPerPageChange}
                rowsPerPage={itemsPerPage}
                page={currentPage - 1}
              />
            </Row>
          )}
          {isOpenCollapse && watchListEntries.length ? (
            <div className="overlay-collapse-open" onClick={toggleCollapse} />
          ) : null}
        </React.Fragment>
      ) : (
        <NoEntriesMessage payload={noEntriesMessage} />
      )}
    </Container>
  );
};

export default WatchListEntriesPage;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/pages/watch-list-entries-page/WatchListEntriesPage.jsx